import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import Icon from "../../components/Icon";
import styles from "./NewProduct.module.sass";
import NameAndDescription from "./NameAndDescription";
import CategoryAndAttibutes from "./CategoryAndAttibutes";
import ProductFiles from "./ProductFiles";
import { Link, useParams, useLocation } from "react-router-dom";

import { createOffer } from "../../services/offer.service";
import { getCurrentCompanyInfo } from "../../services/account.service";

const AlternanceOffer = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState(null);

    // Référence pour accéder à la fonction de synchronisation de l'éditeur
    const editorSyncRef = React.useRef(null);

    // État pour stocker toutes les données de l'offre
    const [offerData, setOfferData] = useState({
        title: '',
        description: '',
        workplace_location: '',
        start_date: '',
        contract_duration: '',
        work_rhythm: '',
        contract_type: '',
        activity_sector: '',
        educational_level_required: '',
        required_experience: '',
        competences: '',
        job_description: '',
        company_id: '',
    });

    // Récupérer les informations de l'entreprise au chargement du composant
    useEffect(() => {
        const fetchCompanyData = async () => {
            try {
                const data = await getCurrentCompanyInfo();
                if (data && data.company) {
                    setCompany(data.company);
                    // Mettre à jour automatiquement le company_id dans les données de l'offre
                    setOfferData(prev => ({
                        ...prev,
                        company_id: data.company.id
                    }));
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données de l'entreprise:", error);
                toast.error("Erreur lors de la récupération des informations de l'entreprise");
            }
        };

        fetchCompanyData();
    }, []);

    // Fonction pour mettre à jour les données de l'offre
    const handleOfferChange = (e) => {
        const { name, value } = e.target;
        setOfferData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Fonction pour gérer les dropdowns
    const handleDropdownChange = (name, value) => {
        setOfferData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Fonction pour gérer les compétences depuis CategoryAndAttibutes
    const handleCompetencesChange = (competences) => {
        setOfferData(prev => ({
            ...prev,
            competences: JSON.stringify(competences) // Stocker les compétences en JSON
        }));
    };

    // Fonction pour sauvegarder l'offre
    const handleSaveOffer = async () => {
        setLoading(true);

        try {
            // Récupérer la description directement depuis l'éditeur
            let currentDescription = offerData.description;
            if (editorSyncRef.current) {
                const syncResult = editorSyncRef.current();
                if (syncResult && typeof syncResult === 'string') {
                    currentDescription = syncResult;
                }
            }

            // Validation des champs requis avec la description actuelle
            if (!offerData.title || offerData.title.trim() === '' || !currentDescription || currentDescription.trim() === '') {
                toast.error("Veuillez remplir tous les champs obligatoires (titre et description)");
                setLoading(false);
                return;
            }

            // Mettre à jour les données avec la description actuelle
            const updatedOfferData = {
                ...offerData,
                description: currentDescription
            };

            // Mapper les champs du formulaire aux champs PocketBase
            const offerToSave = {
                title: offerData.title,
                description: offerData.description,
                job_location: offerData.workplace_location,
                start_date: offerData.start_date,
                during_contrat: parseInt(offerData.contract_duration) || 0,
                rythme: offerData.work_rhythm,
                type_contrat: offerData.contract_type,
                sector_activity: offerData.activity_sector,
                educational_level_required: offerData.educational_level_required,
                required_experience: offerData.required_experience,
                competences: offerData.competences,
                job_description: offerData.job_description,
                company_id: offerData.company_id || '',
            };

            const result = await createOffer(offerToSave);

            if (result.success) {
                toast.success("Offre d'alternance créée avec succès !");
                // Rediriger vers la liste des offres ou le dashboard
                navigate('/company/alternance-offers');
            } else {
                toast.error(`Erreur lors de la création : ${result.error}`);
            }
        } catch (error) {
            console.error('Erreur lors de la sauvegarde:', error);
            toast.error("Une erreur est survenue lors de la création de l'offre");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={styles.shop}>
                <Link className={cn("button-white", styles.button)} to="/company/alternance-offers">
                    <Icon name="arrow-left" />
                    Retour
                </Link>
                <div className={styles.background}>
                    <img src="/images/content/bg-shop.jpg" alt="Background" />
                </div>

                <div className={styles.row}>
                    <div className={styles.col}>
                        <NameAndDescription
                            className={styles.card}
                            offer={offerData}
                            onOfferChange={handleOfferChange}
                            onDropdownChange={handleDropdownChange}
                            editorSyncRef={editorSyncRef}
                        />
                        <CategoryAndAttibutes
                            className={styles.card}
                            offer={offerData}
                            onOfferChange={handleOfferChange}
                            onDropdownChange={handleDropdownChange}
                            onCompetencesChange={handleCompetencesChange}
                        />
                        <ProductFiles
                            className={styles.card}
                            offer={offerData}
                            onOfferChange={handleOfferChange}
                            loading={loading}
                            onSave={handleSaveOffer}
                        />
                    </div>
                </div>
            </div>

        </>
    );
};

export default AlternanceOffer;
